import React, { useState } from 'react';
import htmlLogo from '../assets/html-logo.png';
import cssLogo from '../assets/css-logo.png';
import javascriptLogo from '../assets/javascript-logo.png';
import typescriptLogo from '../assets/typescript-logo.png';
import angularLogo from '../assets/angular-logo.png';
import reactLogo from '../assets/react-logo.png';
import djangoLogo from '../assets/django-logo.png';
import bootstrapLogo from '../assets/bootstrap-logo.png';
import gitLogo from '../assets/git-logo.png';
import nodeLogo from '../assets/node-logo.png';
import firebaseLogo from '../assets/firebase-logo.png';
import strapiLogo from '../assets/strapi-logo.png';
import figmaLogo from '../assets/figma-logo.png';

function Skill() {

    const [htm, setHtm] = useState(false)
    const [css, setCss] = useState(false)
    const [jav, setJav] = useState(false)
    const [typ, setTyp] = useState(false)
    const [ang, setAng] = useState(false)
    const [rea, setRea] = useState(false)
    const [dja, setDja] = useState(false)
    const [boo, setBoo] = useState(false)
    const [git, setGit] = useState(false)
    const [nod, setNod] = useState(false)
    const [fir, setFir] = useState(false)
    const [str, setStr] = useState(false)
    const [fig, setFig] = useState(false)

    return (
        <div className="bg-skill" id="skill">
            <div className="max-skill">
                <h2><i>Skills</i></h2>
                <div>
                    <div className="skill-div">
                        <h3>Languages</h3>
                        <div className="flex-row row-logo-1">
                            <div className={htm ? 'logo-with-word-hover' : ''} onMouseOver={() => setHtm(true)} onMouseLeave={() => setHtm(false)}>
                                <img className={htm ? 'img-logo-hover' : 'img-logo'} src={htmlLogo} alt=""/>
                                <p className={htm ? 'logo-with-word-p' : 'logo-with-word-p-none'}>HTML</p>
                            </div>
                            <div className={css ? 'logo-with-word-hover' : ''} onMouseOver={() => setCss(true)} onMouseLeave={() => setCss(false)}>
                                <img className={css ? 'img-logo-hover' : 'img-logo'} src={cssLogo} alt=""/>
                                <p className={css ? 'logo-with-word-p' : 'logo-with-word-p-none'}>CSS</p>
                            </div>
                            <div className={jav ? 'logo-with-word-hover' : ''} onMouseOver={() => setJav(true)} onMouseLeave={() => setJav(false)}>
                                <img className={jav ? 'img-logo-hover' : 'img-logo'} src={javascriptLogo} alt=""/>
                                <p className={jav ? 'logo-with-word-p' : 'logo-with-word-p-none'}>JavaScript</p>
                            </div>
                            <div className={typ ? 'logo-with-word-hover' : ''} onMouseOver={() => setTyp(true)} onMouseLeave={() => setTyp(false)}>
                                <img className={typ ? 'img-logo-hover' : 'img-logo'} src={typescriptLogo} alt=""/>
                                <p className={typ ? 'logo-with-word-p' : 'logo-with-word-p-none'}>TypeScript</p>
                            </div>
                        </div>
                    </div>
                    <div className="skill-div">
                        <h3>Framework & Libraries</h3>
                        <div className="flex-row row-logo-2">
                            <div className={ang ? 'logo-with-word-hover' : ''} onMouseOver={() => setAng(true)} onMouseLeave={() => setAng(false)}>
                                <img className={ang ? 'img-logo-hover' : 'img-logo'} src={angularLogo} alt=""/>
                                <p className={ang ? 'logo-with-word-p' : 'logo-with-word-p-none'}>Angular</p>
                            </div>
                            <div className={rea ? 'logo-with-word-hover' : ''} onMouseOver={() => setRea(true)} onMouseLeave={() => setRea(false)}>
                                <img className={rea ? 'img-logo-hover' : 'img-logo'} src={reactLogo} alt=""/>
                                <p className={rea ? 'logo-with-word-p' : 'logo-with-word-p-none'}>React</p>
                            </div>
                            <div className={dja ? 'logo-with-word-hover' : ''} onMouseOver={() => setDja(true)} onMouseLeave={() => setDja(false)}>
                                <img className={dja ? 'img-logo-hover' : 'img-logo'} src={djangoLogo} alt=""/>
                                <p className={dja ? 'logo-with-word-p' : 'logo-with-word-p-none'}>Django</p>
                            </div>
                            <div className={boo ? 'logo-with-word-hover' : ''} onMouseOver={() => setBoo(true)} onMouseLeave={() => setBoo(false)}>
                                <img className={boo ? 'img-logo-hover' : 'img-logo'} src={bootstrapLogo} alt=""/>
                                <p className={boo ? 'logo-with-word-p' : 'logo-with-word-p-none'}>Bootstrap</p>
                            </div>
                        </div>
                    </div>
                    <div className="skill-div">
                        <h3>Tools & Platforms</h3>
                        <div className="flex-row row-logo-3">
                            <div className={git ? 'logo-with-word-hover' : ''} onMouseOver={() => setGit(true)} onMouseLeave={() => setGit(false)}>
                                <img className={git ? 'img-logo-hover' : 'img-logo'} src={gitLogo} alt=""/>
                                <p className={git ? 'logo-with-word-p' : 'logo-with-word-p-none'}>git</p>
                            </div>
                            <div className={nod ? 'logo-with-word-hover' : ''} onMouseOver={() => setNod(true)} onMouseLeave={() => setNod(false)}>
                                <img className={nod ? 'img-logo-hover' : 'img-logo'} src={nodeLogo} alt=""/>
                                <p className={nod ? 'logo-with-word-p' : 'logo-with-word-p-none'}>Node</p>
                            </div>
                            <div className={fir ? 'logo-with-word-hover' : ''} onMouseOver={() => setFir(true)} onMouseLeave={() => setFir(false)}>
                                <img className={fir ? 'img-logo-hover' : 'img-logo'} src={firebaseLogo} alt=""/>
                                <p className={fir ? 'logo-with-word-p' : 'logo-with-word-p-none'}>Firebase</p>
                            </div>
                            <div className={str ? 'logo-with-word-hover' : ''} onMouseOver={() => setStr(true)} onMouseLeave={() => setStr(false)}>
                                <img className={str ? 'img-logo-hover' : 'img-logo'} src={strapiLogo} alt=""/>
                                <p className={str ? 'logo-with-word-p' : 'logo-with-word-p-none'}>Strapi</p>
                            </div>
                        </div>
                    </div>
                    <div className="skill-div">
                        <h3>Design Tool</h3>
                        <div className="flex-row row-logo-4">
                            <div className={fig ? 'logo-with-word-hover' : ''} onMouseOver={() => setFig(true)} onMouseLeave={() => setFig(false)}>
                                <img className={fig ? 'img-logo-hover' : 'img-logo'} src={figmaLogo} alt=""/>
                                <p className={fig ? 'logo-with-word-p' : 'logo-with-word-p-none'}>Figma</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Skill
